import { LitElement } from '@lit'
import { formatPrice } from '@nova/utils'

class NovaPrice extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    this.updateContent = this.updateContent.bind(this)
    this.handleQuantityChange = this.handleQuantityChange.bind(this)

    document.addEventListener('nova:product:render-price', this.updateContent)
    document.addEventListener('nova:product:b2b-textile-calculated-price', this.handleQuantityChange)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener('nova:product:render-price', this.updateContent)
    document.removeEventListener('nova:product:b2b-textile-calculated-price', this.handleQuantityChange)
  }

  updateContent(event) {
    const content = event.detail.html
    if (!content) return
    this.innerHTML = content.innerHTML
  }

  handleQuantityChange = (event) => {
    const qty = Math.max(1, Number(event.detail?.value ?? 1));

    // The inline carrier with unit pricing data
    const carrier =
      this.querySelector('.c-grey-600[data-price]') ||
      this.querySelector('[data-price][data-quantity-break]');

    // Optional total element (if you show a calculated total elsewhere)
    const totalEl = this.querySelector('.js-b2b-textile-calculated-price');

    if (!carrier) return;

    const baseCents = Number(carrier.dataset.price || 0);

    // Compute the applicable UNIT price in cents
    let unitCents = baseCents;

    // Prefer multi-breaks if present
    const breaksJson = carrier.dataset.priceBreaks;
    if (breaksJson) {
      try {
        const arr = JSON.parse(breaksJson);
        if (Array.isArray(arr) && arr.length > 0) {
          arr.sort((a, b) => Number(a.quantity) - Number(b.quantity));
          for (const br of arr) {
            if (qty >= Number(br.quantity)) unitCents = Number(br.price);
          }
        }
      } catch { /* ignore and fall back */ }
    } else {
      // Single break from data-price-break / data-quantity-break
      const breakQty = Number(carrier.dataset.quantityBreak || Infinity);
      const breakPrice = Number(carrier.dataset.priceBreak || baseCents);
      if (qty >= breakQty) unitCents = breakPrice;
    }

    // Update the carrier text with the UNIT price
    carrier.textContent = formatPrice(unitCents);

    // If you also show a total elsewhere, update it (qty × unit)
    if (totalEl) {
      totalEl.textContent = formatPrice(qty * unitCents);
    }
  };

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-price', NovaPrice)
